import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from './components/Nav';
import Hero from './components/Hero';
import ProductSpotlight from './components/ProductSpotlight';
import Footer from './components/Footer';
import { initAnalytics, trackPageView } from './lib/analytics';

export default function App() {
	const location = useLocation();

	useEffect(() => {
		initAnalytics();
	}, []);

	useEffect(() => {
		trackPageView(location.pathname);
	}, [location.pathname]);

	useEffect(() => {
		document.title = 'Asmakam LLC — AI-Powered Software Engineering';
	}, []);

	return (
		<div className='bg-slate-950 text-white'>
			<Nav />
			<main id='home'>
				<Hero />
				<ProductSpotlight />
			</main>
			<Footer />
		</div>
	);
}
